import { createTheme } from "@mui/material/styles";
import FbCoherentiSans from "./assets/fonts/FbCoherentiSans-Regular.ttf";
import FbCoherentiSansBold from "./assets/fonts/FbCoherentiSans-Bold.ttf";
import FbCoherentiSansLight from "./assets/fonts/FbCoherentiSans-Light.ttf";
import FbCoherentiSansMedium from "./assets/fonts/FbCoherentiSans-Medium.ttf";

const theme = createTheme({
  typography: {
    fontFamily: "FbCoherentiSans, Arial",
  },
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          backgroundColor: "#E5E5E5",
          "@media (min-width: 600px)": {
            minWidth: 180,
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: `
          @font-face {
            font-family: 'FbCoherentiSans';
            font-style: normal;
            font-display: swap;
            font-weight: 400;
            src: local('FbCoherentiSans'), local('FbCoherentiSans-Regular'), url(${FbCoherentiSans}) format('woff2');
            unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
          }
          @font-face {
            font-family: 'FbCoherentiSans-bold';
            font-style: semi-bold;
            font-display: swap;
            font-weight: 800;
            src: local('FbCoherentiSansBold'), local('FbCoherentiSans-Bold'), url(${FbCoherentiSansBold}) format('woff2');
            unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
          }
          @font-face {
            font-family: 'FbCoherentiSans-light';
            font-style: normal;
            font-display: swap;
            font-weight: 400;
            src: local('FbCoherentiSansLight'), local('FbCoherentiSans-Light'), url(${FbCoherentiSansLight}) format('woff2');
            unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
          }
          @font-face {
            font-family: 'FbCoherentiSans-medium';
            font-style: normal;
            font-display: swap;
            font-weight: 400;
            src: local('FbCoherentiSansMedium'), local('FbCoherentiSans-Medium'), url(${FbCoherentiSansMedium}) format('woff2');
            unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
          }
        `,
    },
  },
});

// h4= des=>1.625 , mobile=> 1.625   26
// h3= des=>2.875 , mobile=> 1.75  24**42
// h2= des=>2.875 , mobile=> 1.75  28**46
// h1= des=>3.25 , mobile=> 1.75 // 28**52
// subtitle1= des=>1.313 , mobile=> 1.125 18**21
// body2= des=>1.125 , mobile=> 1.125 18
// theme.typography.h4 = {
//   fontSize: "1.625rem",
// };
// theme.typography.h3 = {
//   fontSize: "1.5rem",
//   "@media (min-width:600px)": {
//     fontSize: "2.625rem",
//   },
//   //   [theme.breakpoints.up("md")]: {
//   //     fontSize: "2.4rem",
//   //   },
// };
// theme.typography.h2 = {
//   fontSize: "1.75rem",
//   fontFamily: "FbCoherentiSans ,Arial",
//   color: "white",
//   //   "@media (min-width:600)": {
//   //     fontSize: "1.75rem",
//   //     fontFamily: "FbCoherentiSans ,Arial",
//   //     color: "white",
//   //   },
//   "@media (min-width:1400px)": {
//     fontSize: "2.875rem",
//     fontFamily: "FbCoherentiSans ,Arial",
//     color: "white",
//   },
//   //   [theme.breakpoints.up("md")]: {
//   //     fontSize: "2.4rem",
//   //   },
// };
// theme.typography.h1 = {
//   fontSize: "1.75rem",
//   "@media (min-width:600px)": {
//     fontSize: "3.25rem",
//   },
//   //   [theme.breakpoints.up("md")]: {
//   //     fontSize: "2.4rem",
//   //   },
// };
// theme.typography.subtitle1 = {
//   fontSize: "1.125rem",
//   fontFamily: "FbCoherentiSans ,Arial",
//   color: "white",
//   fontWeight: "400",
//   "@media (min-width:1400px)": {
//     fontSize: "1.313rem",
//     fontFamily: "FbCoherentiSans ,Arial",
//     color: "white",
//     fontWeight: "400",
//   },
//   //   [theme.breakpoints.up("md")]: {
//   //     fontSize: "2.4rem",
//   //   },
// };
// theme.typography.body2 = {
//   fontSize: "1.125rem",
// };

export default theme;
